import { type ReactElement } from 'react';
import { useOutletContext } from 'react-router';
import { entreesVisibles } from '../routes.js';

interface Espace { readonly code: string; readonly nom: string; readonly role: string }

/**
 * L'ACCUEIL D'UN ESPACE — provisoire, et qui le DIT.
 *
 * Il sera remplace par un tableau de bord : executions recentes, validations en
 * attente, automatisations en erreur. En attendant, il annonce ce qui vient
 * plutot que d'afficher une page vide -- un ecran muet fait douter que
 * l'application fonctionne.
 */
export function AccueilEspace(): ReactElement {
  const espace = useOutletContext<Espace>();
  const entrees = entreesVisibles(espace.role);

  return (
    <>
      <div className="contenu__entete">
        <div>
          <h1>{espace.nom}</h1>
          <p className="discret">Votre rôle : {espace.role}</p>
        </div>
      </div>

      <div className="carte etat-vide">
        <h3>Le tableau de bord arrive</h3>
        <p className="discret" style={{ maxWidth: 'var(--largeur-lecture)',
                                        margin: '0 auto' }}>
          Il montrera vos exécutions récentes, les validations qui vous attendent
          et les automatisations en difficulté. Les sections ci-dessous
          s’ouvriront une par une.
        </p>
        <ul style={{ marginTop: 'var(--espace-6)', display: 'flex',
                     gap: 'var(--espace-2)', justifyContent: 'center',
                     flexWrap: 'wrap' }}>
          {entrees.map((e) => (
            <li key={e.cle}>
              <span className={e.pret ? 'etiquette etiquette--succes' : 'etiquette'}>
                {e.libelle}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
